export interface TimeState {
  elapsed: number;
  delta: number;
  frame: number;
  update(nowMs: number): void;
}

export function createTimeState(): TimeState {
  let startMs = -1;
  let lastMs = 0;

  const state: TimeState = {
    elapsed: 0,
    delta: 0,
    frame: 0,

    update(nowMs: number) {
      if (startMs < 0) {
        startMs = nowMs;
        lastMs = nowMs;
      }
      state.delta = (nowMs - lastMs) / 1000;
      state.elapsed = (nowMs - startMs) / 1000;
      state.frame++;
      lastMs = nowMs;
    },
  };

  return state;
}
